import React, {useState, useEffect, useRef} from "react";

// react-router components
import {useLocation, Link, useNavigate, NavLink} from "react-router-dom";

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

// @material-ui core components
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import Icon from "@mui/material/Icon";
import Badge from "@mui/material/Badge";
import CircularProgress from "@mui/material/CircularProgress";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";

// Material Dashboard 2 React example components
import Breadcrumbs from "examples/Breadcrumbs";
import NotificationItem from "examples/Items/NotificationItem";

// Custom styles for DashboardNavbar
import {
  navbar,
  navbarContainer,
  navbarRow,
  navbarIconButton,
  navbarMobileMenu,
} from "examples/Navbars/DashboardNavbar/styles";

// Material Dashboard 2 React context
// import {
//   setTransparentNavbar,
//   setMiniSidenav,
//   setOpenConfigurator,
// } from "context";
import { useDispatch, useSelector } from "react-redux";
import {
  Logout,
  notificationList as fetchNotificationListAction,
  notificationRead,
  notificationUnreadCount,
  onSuccessAlert,
  setLanguage,
  setMiniSidenav,
  setOpenConfigurator,
  setTransparentNavbar
} from "../../../actions";
import {createTheme, styled, ThemeProvider} from "@mui/material/styles";
import {
  Dialog, DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle, FormControl,
  FormGroup, FormHelperText,
  InputAdornment, Select
} from "@mui/material";
import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";
import MDTypography from "../../../components/MDTypography";
import LocalStorage from "../../../utils/LocalStorage";
import SearchIcon from '@mui/icons-material/Search';
import Button from "@mui/material/Button";
import PaperComponent from "../../../components/MuiDraggableDialog";
import TextField from "@mui/material/TextField";
import Divider from "@mui/material/Divider";
import Grid from "@mui/material/Grid";
import adminRoutes from "../../../adminRoutes";
import colors from "assets/theme/base/colors";
import {tabsRoutes} from "../../../constants";
import MDButton from "../../../components/MDButton";
import SwapVertIcon from "@mui/icons-material/SwapVert";
import MenuItem from "@mui/material/MenuItem";
import LanguageIcon from '@mui/icons-material/Language';
import moment from "moment";
import {checkPermission, PERMISSION_DICT} from "../../../utils/Users_Roles_Permission";
import {formatContent, richTextSx} from "../../../utils/EditorHelper";

const muiTheme = createTheme({
  slider: {
    trackColor: "yellow",
    selectionColor: "green"
  }
});

const notificationLevelMap = {
  1: { label: "Info", icon: "info", color: "#3B82F6", bg: "#EAF2FF", unreadBg: "#F3F8FF", readBg: "#FFFFFF" },
  2: { label: "Warning", icon: "error_outline", color: "#F59E0B", bg: "#FFF4DE", unreadBg: "#FFF9EC", readBg: "#FFFFFF" },
  3: { label: "Error", icon: "warning_amber", color: "#EF4444", bg: "#FEECEC", unreadBg: "#FFF5F5", readBg: "#FFFFFF" },
  4: { label: "Critical", icon: "priority_high", color: "#991B1B", bg: "#FDE4E8", unreadBg: "#FFF1F3", readBg: "#FFFFFF" },
};

const notificationSeenKey = "notification_last_seen_id";

const getNotificationTime = (notification) => notification?.addTime || notification?.readTime || "";

const getNotificationId = (notification) => notification?.id || notification?.bizId || getNotificationTime(notification);

const getNotificationContent = (notification) => notification?.content || notification?.contentPreview || "";

const isNotificationUnread = (notification) => notification?.isRead === false || notification?.isRead === 0;

const getNotificationGroup = (notification) => {
  const time = getNotificationTime(notification);

  if (!time || !moment(time).isValid()) {
    return "Older";
  }

  if (moment(time).isSame(moment(), "day")) {
    return "Today";
  }

  if (moment(time).isSame(moment().subtract(1, "day"), "day")) {
    return "Yesterday";
  }

  return "Older";
};

const groupNotifications = (notifications) => {
  const groups = {
    Today: [],
    Yesterday: [],
    Older: [],
  };

  notifications.forEach((notification) => {
    groups[getNotificationGroup(notification)].push(notification);
  });

  return Object.entries(groups).filter(([, rows]) => rows.length);
};

const getVisibleNotificationRows = (notifications, unreadOnly) => {
  if (!unreadOnly) {
    return notifications;
  }

  return notifications.filter((notification) => isNotificationUnread(notification));
};

function DashboardNavbar({ absolute, light, isMini }) {
  const languageList = [
    {
      id: 1,
      label: 'En',
      lang:'en',
      value: 1
    },
    {
      id: 2,
      label: '中文',
      lang:'zh',
      value: 2
    },
    {
      id: 3,
      label: 'Fr',
      lang:'fr',
      value: 3
    },
  ]
  const [navbarType, setNavbarType] = useState();
  const nav = useNavigate()
  const dispatch = useDispatch()
  const [openMenu, setOpenMenu] = useState(false);
  const [openAccount , setOpenAccount] = useState(false)
  const [openSupport , setOpenSupport] = useState(false)
  const [openHelpCenter , setOpenHelpCenter] = useState(false)
  const route = useLocation().pathname.split("/").slice(1);
  const fixedNavbar = useSelector(state => state?.common?.fixedNavbar)
  const miniSidenav = useSelector(state => state?.common?.miniSidenav)
  const transparentNavbar = useSelector(state => state?.common?.transparentNavbar)
  const sidenavColor = useSelector(state => state?.common?.sidenavColor)
  const openConfigurator = useSelector(state => state?.common?.openConfigurator)
  const darkMode = useSelector(state => state?.common?.darkMode)
  const language = useSelector(state => state?.common?.language)
  const canListNotifications = checkPermission(PERMISSION_DICT.MessageNotificationList);
  const canReadNotifications = checkPermission(PERMISSION_DICT.MessageNotificationRead);
  const [searchHistory, setSearchHistory] = useState([]);
  const [searchValue, setSearchValue] = useState("")
  const { t, i18n } = useTranslation();
  const [filteredList , setFilteredList] = useState([]);
  const [languageSelect ,setLanguageSelect] = useState(languageList.find((lang)=>lang.lang === i18n.language).value);
  const [openLanguageSelect,setOpenLanguageSelect] = useState(false);
  const [notificationRows, setNotificationRows] = useState([]);
  const [notificationTotal, setNotificationTotal] = useState(0);
  const [notificationPage, setNotificationPage] = useState(1);
  const [notificationUnreadOnly, setNotificationUnreadOnly] = useState(false);
  const [notificationLoading, setNotificationLoading] = useState(false);
  const [notificationLoadingMore, setNotificationLoadingMore] = useState(false);
  const [notificationRefreshing, setNotificationRefreshing] = useState(false);
  const [notificationHasMore, setNotificationHasMore] = useState(false);
  const [notificationBadgeCount, setNotificationBadgeCount] = useState(0);
  const [notificationUnreadCountValue, setNotificationUnreadCountValue] = useState(0);
  const [expandedNotificationId, setExpandedNotificationId] = useState(null);
  const [locallyReadNotificationIds, setLocallyReadNotificationIds] = useState(() => new Set());
  const notificationLatestIdRef = useRef(LocalStorage.getItem(notificationSeenKey) || "");
  const notificationRequestingRef = useRef(false);
  const notificationDetectingRef = useRef(false);
  const notificationReadingRef = useRef(false);
  const notificationPageRef = useRef(1);
  const notificationRowsRef = useRef([]);
  const notificationOpenRef = useRef(false);
  const notificationUnreadOnlyRef = useRef(false);
  const notificationListRef = useRef(null);
  const locallyReadNotificationIdsRef = useRef(new Set());
  const viewAllReadNotificationIdsRef = useRef(new Set());
  const pendingNotificationRowsRef = useRef([]);

  useEffect(() => {
    notificationRowsRef.current = notificationRows;
  }, [notificationRows]);

  useEffect(() => {
    notificationOpenRef.current = Boolean(openMenu);
  }, [openMenu]);

  useEffect(() => {
    notificationUnreadOnlyRef.current = notificationUnreadOnly;
  }, [notificationUnreadOnly]);

  useEffect(() => {
    // 确保语言在组件加载时同步
    const language = i18n.language || 'en'; // 默认语言是 'en'
    setLanguageSelect(languageList.find((lang) => lang.lang === language)?.value );
  }, [i18n.language]);

  useEffect(() => {
    const currentSearchHistory = LocalStorage.getItem("searchHistory")
        ? JSON.parse(LocalStorage.getItem("searchHistory"))
        : [];
    setSearchHistory(currentSearchHistory);
  }, []);

  useEffect(() => {
    const handleKeyDown = (event) => {
      // 检测 Command + K 或 Ctrl + K
      if ((event.metaKey || event.ctrlKey) && event.key === "k") {
        event.preventDefault(); // 阻止默认行为（如浏览器快捷键）
        setSearchValue("")
        setOpenHelpCenter((prev) => !prev); // 切换搜索状态
      }
    };

    // 绑定事件监听
    window.addEventListener("keydown", handleKeyDown);

    // 清理事件监听
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  function extractItems(list, keys, parentRoute = "") {
    const result = [];

    list.forEach((item) => {
      const currentRoute = parentRoute + item.route;

      // 如果当前元素符合条件，添加到结果中
      if (keys.includes(item.key) && !item.children) {
        result.push({ ...item, route: currentRoute }); // 拼接父级路由
      }

      // 如果有 children，递归调用函数
      if (item.children) {
        result.push(
            ...extractItems(item.children, keys, currentRoute) // 递归传递当前的路由作为父级路由
        );
      }
    });
    return result;
  }
  // const filteredList = [...extractItems(adminRoutes, menuList), ...tabsRoutes];

  const menuList = JSON.parse(LocalStorage.getItem('keys'))
  useEffect(() => {
    setFilteredList([...extractItems(adminRoutes, menuList), ...tabsRoutes()]);
  },[openHelpCenter])

  const getSearchHistoryList = () => {
    const currentSearchHistory = LocalStorage.getItem("searchHistory")
        ? JSON.parse(LocalStorage.getItem("searchHistory"))
        : [];

    // 按 currentSearchHistory 的顺序生成列表
    return currentSearchHistory
        .map(key => filteredList.find(item => item.key === key)) // 按顺序查找
        .filter(Boolean); // 去掉 undefined 的项（即不存在于 filteredList 的项）
  };

  const filteredSearchList = getSearchHistoryList()

  useEffect(() => {
    // Setting the navbar type
    if (fixedNavbar) {
      setNavbarType("sticky");
    } else {
      setNavbarType("static");
    }

    // A function that sets the transparent state of the navbar.
    function handleTransparentNavbar() {
      dispatch(setTransparentNavbar((fixedNavbar && window.scrollY === 0) || !fixedNavbar))
    }

    /** 
     The event listener that's calling the handleTransparentNavbar function when 
     scrolling the window.
    */
    window.addEventListener("scroll", handleTransparentNavbar);

    // Call the handleTransparentNavbar function to set the state with the initial value.
    handleTransparentNavbar();

    // Remove event listener on cleanup
    return () => window.removeEventListener("scroll", handleTransparentNavbar);
  }, [dispatch, fixedNavbar]);

  const handleMiniSidenav = () => dispatch(setMiniSidenav( !miniSidenav))
  const handleConfiguratorOpen = () => dispatch(setOpenConfigurator( !openConfigurator))

  const handleToggleLanguage = () => {
    // if(language === 'en'){
    //     dispatch(setLanguage('zh'))
    //     i18n.changeLanguage('zh')
    // } else {
    //     dispatch(setLanguage('en'))
    //     i18n.changeLanguage('en')
    // }
    if (language === 'en') {
      dispatch(setLanguage('zh'));
      i18n.changeLanguage('zh');
    } else if (language === 'zh') {
      dispatch(setLanguage('fr'));
      i18n.changeLanguage('fr');
    } else {
      dispatch(setLanguage('en'));
      i18n.changeLanguage('en');
    }
  }

  const handleOpenHelpCenter = (event) => setOpenHelpCenter(event.currentTarget);

  const handleCloseHelpCenter = () => {
    setSearchValue("")
    setOpenHelpCenter(false)
  };

  const handleOpenAccount = (event) => setOpenAccount(event.currentTarget);

  const handleCloseAccount = () => setOpenAccount(false);

  const handleOpenSupport = (event) => setOpenSupport(event.currentTarget);

  const handleCloseSupport = () => setOpenSupport(false);
  const handleOpenMenu = (event) => {
    setOpenMenu(event.currentTarget);
    if (notificationLatestIdRef.current) {
      LocalStorage.setItem(notificationSeenKey, notificationLatestIdRef.current);
    }
  };
  const handleCloseMenu = () => setOpenMenu(false);

  const onLogOutSuccess = (msg) => {
    dispatch(onSuccessAlert(t(msg)))
    nav('/authentication/sign-in')
  }

  const handleLogout = () => {
    dispatch(Logout(onLogOutSuccess))
  }

  const fetchNotificationUnreadCount = async () => {
    if (!canListNotifications) return;

    const handleSuccess = (responseData) => {
      const count = responseData?.data?.unreadCount ?? responseData?.data ?? 0;
      const visibleCount = Math.max(Number(count || 0) - locallyReadNotificationIdsRef.current.size, 0);
      setNotificationUnreadCountValue(visibleCount);
      setNotificationBadgeCount(visibleCount);
    };

    await dispatch(notificationUnreadCount(handleSuccess, () => {}));
  };

  const fetchNotificationList = async ({ page = notificationPage, unreadOnly = notificationUnreadOnly, silent = false, append = false } = {}) => {
    if (!canListNotifications) return;
    if (notificationRequestingRef.current) return;
    notificationRequestingRef.current = true;
    if (!silent) setNotificationLoading(true);
    if (append) setNotificationLoadingMore(true);

    try {
      const requestData = {
        pageNum: page,
        pageSize: 10,
      };

      if (unreadOnly) {
        requestData.isRead = false;
      }

      const handleSuccess = (responseData) => {
        const data = responseData?.data || {};
        const rows = Array.isArray(data.rows) ? data.rows : [];
        const normalizedRows = applyLocalNotificationReads(rows, unreadOnly);
        const latestId = rows.length ? String(getNotificationId(rows[0])) : "";

        if (latestId) {
          notificationLatestIdRef.current = latestId;
        }

        if (openMenu || !silent) {
          setNotificationRows((prevRows) => (append ? [...prevRows, ...normalizedRows] : normalizedRows));
          setNotificationTotal(data.total || 0);
          setNotificationHasMore((page * 10) < (data.total || 0));
        }
      };

      const handleError = () => {
        if (!silent) {
          setNotificationRows([]);
          setNotificationTotal(0);
          setNotificationHasMore(false);
        }
      };

      await dispatch(fetchNotificationListAction(requestData, handleSuccess, handleError));
    } catch (error) {
      if (!silent) {
        setNotificationRows([]);
        setNotificationTotal(0);
        setNotificationHasMore(false);
      }
    } finally {
      notificationRequestingRef.current = false;
      if (!silent) setNotificationLoading(false);
      if (append) setNotificationLoadingMore(false);
    }
  };

  const clearPendingNotificationRows = () => {
    pendingNotificationRowsRef.current = [];
  };

  const applyLocalNotificationReads = (rows, unreadOnly = false) => {
    const locallyReadIds = locallyReadNotificationIdsRef.current;
    const viewAllReadIds = viewAllReadNotificationIdsRef.current;

    if (unreadOnly) {
      return rows.filter((item) => !viewAllReadIds.has(String(getNotificationId(item))));
    }

    const normalizedRows = rows.map((item) => (
        locallyReadIds.has(String(getNotificationId(item))) ? { ...item, isRead: 1 } : item
    ));

    return normalizedRows;
  };

  const prependPendingNotificationRows = () => {
    const pendingRows = pendingNotificationRowsRef.current;
    if (!pendingRows.length) return;

    pendingNotificationRowsRef.current = [];
    setNotificationRows((prevRows) => {
      const existingIds = new Set(prevRows.map((item) => String(getNotificationId(item))));
      const rowsToPrepend = applyLocalNotificationReads(
          pendingRows.filter((item) => !existingIds.has(String(getNotificationId(item)))),
          notificationUnreadOnlyRef.current
      );
      if (!rowsToPrepend.length) return prevRows;

      setNotificationTotal((total) => Number(total || 0) + rowsToPrepend.length);
      return [...rowsToPrepend, ...prevRows];
    });
  };

  const checkNewNotifications = async () => {
    if (!canListNotifications) return;
    const currentRows = notificationRowsRef.current;
    const unreadOnly = notificationUnreadOnlyRef.current;

    if (!notificationOpenRef.current || notificationDetectingRef.current || !currentRows.length) return;
    notificationDetectingRef.current = true;

    const requestData = {
      pageNum: 1,
      pageSize: 10,
    };

    if (unreadOnly) {
      requestData.isRead = false;
    }

    const handleSuccess = (responseData) => {
      const rows = Array.isArray(responseData?.data?.rows) ? responseData.data.rows : [];
      const currentFirstId = String(getNotificationId(currentRows[0]));
      const currentFirstIndex = rows.findIndex((item) => String(getNotificationId(item)) === currentFirstId);

      if (currentFirstIndex > 0) {
        pendingNotificationRowsRef.current = rows.slice(0, currentFirstIndex);
      } else if (currentFirstIndex === -1 && rows.length) {
        pendingNotificationRowsRef.current = rows;
      } else {
        clearPendingNotificationRows();
      }

      if ((notificationListRef.current?.scrollTop || 0) <= 40) {
        prependPendingNotificationRows();
      }
    };

    try {
      await dispatch(fetchNotificationListAction(requestData, handleSuccess, () => {}));
    } finally {
      notificationDetectingRef.current = false;
    }
  };

  const refreshNotificationListFromStart = () => {
    clearPendingNotificationRows();
    setNotificationPage(1);
    notificationPageRef.current = 1;
    setExpandedNotificationId(null);
    fetchNotificationList({ page: 1, unreadOnly: notificationUnreadOnly }).then();
  };

  const handleRefreshNotificationList = async () => {
    if (notificationRefreshing || notificationRequestingRef.current) return;

    clearPendingNotificationRows();
    setNotificationRefreshing(true);
    setNotificationPage(1);
    notificationPageRef.current = 1;
    setExpandedNotificationId(null);

    if (notificationListRef.current) {
      notificationListRef.current.scrollTop = 0;
    }

    await fetchNotificationList({ page: 1, unreadOnly: notificationUnreadOnly });
    await fetchNotificationUnreadCount();
    setNotificationRefreshing(false);
  };

  useEffect(() => {
    if (!canListNotifications) return;

    fetchNotificationList({ page: 1, unreadOnly: false, silent: true }).then();
    fetchNotificationUnreadCount().then();

    const timer = setInterval(() => {
      fetchNotificationUnreadCount().then();
      checkNewNotifications().then();
    }, 5000);

    return () => clearInterval(timer);
  }, [canListNotifications]);

  useEffect(() => {
    if (openMenu && canListNotifications) {
      refreshNotificationListFromStart();
    }
  }, [openMenu, notificationUnreadOnly, canListNotifications]);

  const handleNotificationUnreadOnlyChange = (event) => {
    const nextUnreadOnly = event.target.checked;

    if (notificationUnreadOnly && !nextUnreadOnly && locallyReadNotificationIdsRef.current.size && canReadNotifications) {
      handleReadNotifications([...locallyReadNotificationIdsRef.current]).then();
    }

    setNotificationUnreadOnly(nextUnreadOnly);
  };

  const handleNotificationScroll = (event) => {
    const { scrollTop, clientHeight, scrollHeight } = event.currentTarget;
    const topPrependOffset = 40;
    const preloadOffset = 160;

    if (scrollTop <= topPrependOffset) {
      prependPendingNotificationRows();
    }

    if (!notificationHasMore || notificationLoadingMore || notificationRequestingRef.current) return;

    if (scrollHeight - scrollTop - clientHeight <= preloadOffset) {
      const nextPage = notificationPageRef.current + 1;
      notificationPageRef.current = nextPage;
      setNotificationPage(nextPage);
      fetchNotificationList({
        page: nextPage,
        unreadOnly: notificationUnreadOnly,
        silent: true,
        append: true,
      }).then();
    }
  };

  const handleReadNotifications = async (msgIds = []) => {
    if (!canReadNotifications) return;
    if (notificationReadingRef.current) return;
    notificationReadingRef.current = true;

    const handleSuccess = () => {
      const readIdSet = new Set(msgIds.map((msgId) => String(msgId)));

      if (!msgIds.length) {
        locallyReadNotificationIdsRef.current = new Set();
        viewAllReadNotificationIdsRef.current = new Set();
      } else {
        locallyReadNotificationIdsRef.current = new Set(
            [...locallyReadNotificationIdsRef.current].filter((id) => !readIdSet.has(id))
        );
        viewAllReadNotificationIdsRef.current = new Set(
            [...viewAllReadNotificationIdsRef.current].filter((id) => !readIdSet.has(id))
        );
      }
      setLocallyReadNotificationIds(new Set(locallyReadNotificationIdsRef.current));

      setNotificationRows((prevRows) => {
        if (!msgIds.length) {
          return prevRows.map((item) => ({ ...item, isRead: 1 }));
        }

        return prevRows.map((item) => (
            readIdSet.has(String(getNotificationId(item))) ? { ...item, isRead: 1 } : item
        ));
      });

      fetchNotificationUnreadCount().then();
    };

    try {
      await dispatch(notificationRead({ msgIds }, handleSuccess, () => {}));
    } finally {
      notificationReadingRef.current = false;
    }
  };

  const markNotificationReadLocally = (notification) => {
    if (!isNotificationUnread(notification)) return;

    const readId = String(getNotificationId(notification));
    if (locallyReadNotificationIdsRef.current.has(readId)) return;

    locallyReadNotificationIdsRef.current.add(readId);
    if (!notificationUnreadOnlyRef.current) {
      viewAllReadNotificationIdsRef.current.add(readId);
    }
    setLocallyReadNotificationIds((prev) => {
      const next = new Set(prev);
      next.add(readId);
      return next;
    });
    if (!notificationUnreadOnlyRef.current) {
      setNotificationRows((prevRows) => prevRows.map((item) => (
          String(getNotificationId(item)) === readId ? { ...item, isRead: 1 } : item
      )));
    }
    setNotificationUnreadCountValue((count) => Math.max(Number(count || 0) - 1, 0));
    setNotificationBadgeCount((count) => Math.max(Number(count || 0) - 1, 0));
  };

  const handleNotificationItemClick = (notification, notificationId) => {
    const isExpanded = expandedNotificationId === notificationId;
    const previousExpandedNotification = notificationRows.find((item) => (
        `${getNotificationId(item)}-${getNotificationTime(item)}` === expandedNotificationId
    ));

    markNotificationReadLocally(notification);
    if (!notificationUnreadOnly && isNotificationUnread(notification) && canReadNotifications) {
      handleReadNotifications([getNotificationId(notification)]).then();
    }
    setExpandedNotificationId(isExpanded ? null : notificationId);

    if (
        notificationUnreadOnly &&
        isExpanded &&
        locallyReadNotificationIdsRef.current.has(String(getNotificationId(notification))) &&
        canReadNotifications
    ) {
      handleReadNotifications([getNotificationId(notification)]).then();
    }

    if (
        notificationUnreadOnly &&
        !isExpanded &&
        previousExpandedNotification &&
        isNotificationUnread(previousExpandedNotification) &&
        canReadNotifications
    ) {
      handleReadNotifications([getNotificationId(previousExpandedNotification)]).then();
    }
  };

  const renderNotificationItem = (notification) => {
    const level = notificationLevelMap[notification?.level] || notificationLevelMap[1];
    const time = getNotificationTime(notification);
    const notificationId = `${getNotificationId(notification)}-${getNotificationTime(notification)}`;
    const unread = isNotificationUnread(notification) && !locallyReadNotificationIds.has(String(getNotificationId(notification)));
    const expanded = expandedNotificationId === notificationId;
    const content = getNotificationContent(notification);
    const formattedContent = content ? formatContent(content) : "";

    return (
        <MDBox
            key={notificationId}
            px={1.45}
            py={0}
        >
          <MDBox
              display="flex"
              alignItems="flex-start"
              gap={1.2}
              sx={{
                position: "relative",
                py: 1.15,
                pl: 0,
                pr: 1.1,
                borderBottom: "1px solid #DCE3EC",
                borderLeft: `4px solid ${level.color}`,
                borderRadius: "4px",
                backgroundColor: unread ? level.unreadBg : "#fff",
                cursor: "pointer",
                overflow: "visible",
                transition: "background-color 140ms ease, border-color 140ms ease",
                "&:hover": {
                  backgroundColor: unread ? level.unreadBg : "#fff",
                  borderBottomColor: "#CBD5E1",
                },
                "&:hover .notification-level-avatar": {
                  boxShadow: `0 0 0 3px ${level.bg}`,
                },
              }}
              onClick={() => handleNotificationItemClick(notification, notificationId)}
          >
            <MDBox
                width="34px"
                height="34px"
                borderRadius="50%"
                display="flex"
                alignItems="center"
                justifyContent="center"
                className="notification-level-avatar"
                sx={{
                  mt: 0.15,
                  backgroundColor: level.bg,
                  color: level.color,
                  flex: "0 0 34px",
                  ml: 1.1,
                  boxShadow: "none",
                }}
            >
              <Icon
                  sx={{
                    color: level.color,
                    fontSize: "30px !important",
                    lineHeight: 1,
                  }}
              >
                {level.icon}
              </Icon>
            </MDBox>
            <MDBox flex={1} minWidth={0}>
              <MDBox display="flex" alignItems="center" gap={0.8} minWidth={0}>
                <MDTypography
                    variant="button"
                    fontWeight="bold"
                    color="dark"
                    sx={{
                      flex: 1,
                      minWidth: 0,
                      lineHeight: 1.25,
                      fontSize: "0.8rem",
                      color: unread ? "#0F172A" : "#334155",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                    }}
                >
                  {notification?.title || "Notification"}
                </MDTypography>
              </MDBox>
              {content && (
                  <MDBox
                      mt={0.35}
                      sx={{
                        ...richTextSx,
                        display: "block",
                        color: unread ? "#334155" : "#64748B",
                        fontWeight: unread ? 700 : 600,
                        lineHeight: 1.35,
                        overflow: "hidden",
                        textOverflow: expanded ? "clip" : "ellipsis",
                        whiteSpace: expanded ? "normal" : "nowrap",
                        fontSize: "0.75rem",
                        wordBreak: "break-word",
                        "& p": {
                          margin: 0,
                          display: expanded ? "block" : "inline",
                        },
                        "& strong": {
                          fontWeight: 800,
                        },
                        "& span": {
                          fontSize: "inherit",
                        },
                        "& *": {
                          lineHeight: 1.35,
                          whiteSpace: expanded ? "normal" : "nowrap",
                          display: expanded ? undefined : "inline",
                        },
                      }}
                      dangerouslySetInnerHTML={{ __html: formattedContent }}
                  />
              )}
              {time && (
                  <MDTypography
                      mt={0.45}
                      variant="caption"
                      sx={{
                        display: "block",
                        color: "#94A3B8",
                        fontWeight: 700,
                        fontSize: "0.66rem",
                      }}
                  >
                    {moment(time).format("DD MMMM, YYYY - h:mm A")}
                  </MDTypography>
              )}
            </MDBox>
            {unread && (
                <MDBox
                    width="7px"
                    height="7px"
                    borderRadius="50%"
                    sx={{
                      backgroundColor: level.color,
                      position: "absolute",
                      right: 10,
                      top: 12,
                    }}
                />
            )}
          </MDBox>
        </MDBox>
    );
  };

  // Render the notifications menu
  const renderMenu = () => {
    const visibleNotificationRows = getVisibleNotificationRows(notificationRows, notificationUnreadOnly);

    return (
    <Menu
      anchorEl={openMenu}
      anchorReference={null}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      open={Boolean(openMenu)}
      onClose={handleCloseMenu}
      sx={{
        mt: 1,
        "& .MuiList-root": {
          py: 0,
        },
      }}
      PaperProps={{
        sx: {
          width: 500,
          maxWidth: "calc(100vw - 32px)",
          maxHeight: "calc(100vh - 96px)",
          overflow: "hidden",
          borderRadius: "12px",
          boxShadow: "0 18px 45px rgba(15, 23, 42, 0.18)",
          border: "1px solid #E5E7EB",
        },
      }}
    >
      <MDBox px={1.25} pt={0.9} pb={0.45} sx={{ backgroundColor: "#fff" }}>
        <MDBox display="flex" alignItems="center" justifyContent="space-between">
          <MDTypography sx={{ fontSize: "1.2rem", fontWeight: 900, color: "#111827", letterSpacing: 0 }}>
            Notifications ({notificationTotal || 0})
          </MDTypography>
          <IconButton
              size="small"
              onClick={handleCloseMenu}
              sx={{
                width: 30,
                height: 30,
                border: "1px solid #E5E7EB",
                borderRadius: "8px",
                color: "#6B7280",
              }}
          >
            <Icon fontSize="small">close</Icon>
          </IconButton>
        </MDBox>
        <MDBox display="flex" alignItems="center" justifyContent="space-between" gap={2} mt={0.9}>
          <MDBox display="flex" alignItems="center" gap={0.75}>
            <MDBox
                display="flex"
                alignItems="center"
                gap={0}
                sx={{
                  width: "fit-content",
                  backgroundColor: "#F8FAFC",
                  border: "1px solid #E5E7EB",
                  borderRadius: "8px",
                  overflow: "hidden",
                }}
            >
              <MDTypography
                  component="button"
                  onClick={() => handleNotificationUnreadOnlyChange({ target: { checked: false } })}
                  sx={{
                    px: 1.1,
                    py: 0.55,
                    border: 0,
                    borderRight: "1px solid #E5E7EB",
                    backgroundColor: !notificationUnreadOnly ? "#111827" : "transparent",
                    color: !notificationUnreadOnly ? "#fff" : "#64748B",
                    fontSize: "0.72rem",
                    fontWeight: 800,
                    cursor: "pointer",
                  }}
              >
                View all
              </MDTypography>
              <MDTypography
                  component="button"
                  onClick={() => handleNotificationUnreadOnlyChange({ target: { checked: true } })}
                  sx={{
                    px: 1.1,
                    py: 0.55,
                    border: 0,
                    backgroundColor: notificationUnreadOnly ? "#111827" : "transparent",
                    color: notificationUnreadOnly ? "#fff" : "#64748B",
                    fontSize: "0.72rem",
                    fontWeight: 800,
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    gap: 0.6,
                  }}
              >
                <span>Unread</span>
              </MDTypography>
            </MDBox>
            <IconButton
                size="small"
                onClick={handleRefreshNotificationList}
                disabled={notificationRefreshing}
                sx={{
                  width: 30,
                  height: 30,
                  border: "1px solid #E5E7EB",
                  borderRadius: "8px",
                  color: "#475569",
                  backgroundColor: "#fff",
                  "&:hover": {
                    backgroundColor: "#F8FAFC",
                  },
                }}
            >
              {notificationRefreshing ? (
                  <CircularProgress size={15} />
              ) : (
                  <Icon sx={{ fontSize: "1rem !important" }}>refresh</Icon>
              )}
            </IconButton>
          </MDBox>
          {canReadNotifications && (
              <MDButton
                  variant="text"
                  color="info"
                  onClick={() => handleReadNotifications([])}
                  sx={{ p: 0, minWidth: 0, fontSize: "0.72rem", fontWeight: 900, whiteSpace: "nowrap" }}
              >
                Mark all as read
              </MDButton>
          )}
        </MDBox>
      </MDBox>
      <MDBox
          ref={notificationListRef}
          onScroll={handleNotificationScroll}
          sx={{ maxHeight: 500, overflowY: "auto", backgroundColor: "#fff", py: 0.15 }}
      >
        {notificationLoading ? (
            <MDBox py={5} display="flex" flexDirection="column" alignItems="center" gap={1}>
              <CircularProgress size={24} />
              <MDTypography variant="caption" sx={{ color: "#111827", fontWeight: 700 }}>Loading notifications...</MDTypography>
            </MDBox>
        ) : visibleNotificationRows.length ? (
            groupNotifications(visibleNotificationRows).map(([group, rows]) => (
                <MDBox key={group}>
                  <MDTypography
                      display="block"
                      px={1.45}
                      pt={1.25}
                      pb={0.35}
                      sx={{
                        color: "#111827",
                        fontSize: "0.78rem",
                        fontWeight: 900,
                      }}
                  >
                    {group}
                  </MDTypography>
                  {rows.map(renderNotificationItem)}
                </MDBox>
            ))
        ) : (
            <MDBox py={5} px={3} textAlign="center">
              <MDBox
                  width="42px"
                  height="42px"
                  borderRadius="50%"
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                  mx="auto"
                  mb={1.25}
                  sx={{ backgroundColor: "#f3f5f7", color: "#7b809a" }}
              >
                <Icon fontSize="small">notifications_none</Icon>
              </MDBox>
              <MDTypography variant="button" fontWeight="medium" color="dark">
                No notifications
              </MDTypography>
              <MDTypography display="block" variant="caption" color="text" mt={0.25}>
                New messages will appear here.
              </MDTypography>
            </MDBox>
        )}
        {notificationLoadingMore && (
            <MDBox py={1.25} display="flex" alignItems="center" justifyContent="center" gap={1}>
              <CircularProgress size={16} />
              <MDTypography variant="caption" sx={{ color: "#64748B", fontWeight: 700 }}>
                Loading more...
              </MDTypography>
            </MDBox>
        )}
      </MDBox>
    </Menu>
    );
  };

  const renderAccount = () => (
      <Menu
      anchorEl={openAccount}
      anchorReference={null}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      open={Boolean(openAccount)}
      onClose={handleCloseAccount}
      sx={{ mt: 2 }}
  >
    <NotificationItem onClick={handleLogout} icon={<Icon>logout</Icon>} title={t("Log Out")}/>
  </Menu>)

  // const renderSupport = () => (
  //     <Menu
  //         anchorEl={openSupport}
  //         anchorReference={null}
  //         anchorOrigin={{
  //           vertical: "bottom",
  //           horizontal: "left",
  //         }}
  //         open={Boolean(openSupport)}
  //         onClose={handleCloseSupport}
  //         sx={{ mt: 2 }}
  //     >
  //       <NotificationItem onClick={() => window.open('https://darwynnfulfillment.freshdesk.com', '_blank')} icon={<Icon>support_agent</Icon>} title="Ticket System" />
  //       <NotificationItem onClick={() => window.open('https://darwynndispatch.freshdesk.com', '_blank')} icon={<Icon>calendar_today</Icon>} title="Schedule LTL/FTL" />
  //     </Menu>)

  const renderHelpCenter = () => {
    const inputRef = useRef(null); // 创建引用

    useEffect(() => {
      if (openHelpCenter) {
        setTimeout(() => {
          if (inputRef.current) {
            inputRef.current.focus();
          }
        }, 0); // 等待下一个事件循环
      }
    }, [openHelpCenter]); // 监听 openHelpCenter 的变化

    const getSearchResult = () =>{
        return filteredList?.filter((v)=>v.chineseName.includes(searchValue.trim())
            || v.name.toLowerCase().includes(searchValue.trim().toLowerCase())
            || v.key?.replace(/[^a-zA-Z0-9]/g, "").toLowerCase().includes(searchValue.trim().toLowerCase())
        )
    }

    return  <Dialog
        open={openHelpCenter}
        onClose={handleCloseHelpCenter}
        PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title"
        scroll={'paper'}
        fullWidth={true}
        // maxWidth={'md'}
        sx={{
          "& .MuiDialog-container": {
            alignItems: "flex-start", // 强制顶部对齐
          },
          "& .MuiDialog-paper": {
            marginTop: "20px", // 距离顶部的间距
            minWidth: "600px",
            minHeight: "150px",
            "@media (max-width: 600px)": {
              minWidth: "90%", // 移动端填满屏幕宽度
            },
            maxHeight: "600px",
          },
        }}
        TransitionProps={{
          onEntered: () => {
            if (inputRef.current) {
              inputRef.current.focus();
            }
          },
        }}
        disableAutoFocus
        disableEnforceFocus
    >
      <DialogTitle style={{ cursor: 'move', display: 'flex', justifyContent: 'space-between' ,paddingBottom:"0px"}}
                   id="draggable-dialog-title">
        <MDBox sx={{display:"flex", alignItems:"center", width: '100%',}}>
          <SearchIcon fontSize={"medium"} sx={{marginRight:"10px"}}/> {/* 设置图标大小 */}
          <TextField
              id="input-with-icon-textfield"
              placeholder={t("HelpCenter.What are you looking for?")}
              variant="standard"
              name={`unique-name-${Math.random().toString(36).substr(2, 9)}`} // 动态生成唯一的 name
              autoComplete="off" // 禁用自动填充
              inputProps={{
                autoComplete: "new-password", // 更强制的禁用方式，避免某些浏览器忽略 "off"
              }}
              value={searchValue}
              onChange={(event) => {
                setSearchValue(event.target.value)
              }}
              inputRef={inputRef} // 绑定输入框引用
              sx={{
                width: '100%',
                "& .MuiInputBase-input": {
                  fontSize: "20px", // 设置输入文字大小
                },
                "& .MuiInput-underline:before": {
                  borderBottom: "none",
                },
                "& .MuiInput-underline:after": {
                  borderBottom: "none",
                },
                "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
                  borderBottom: "none",
                },
              }}
          />
        </MDBox>
        <IconButton size="medium" onClick={handleCloseHelpCenter}>
          <Icon>cancel</Icon>
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          <Divider />
          <MDBox pb={2} px={3} sx={{display: 'flex', justifyContent: 'space-between'}}>
            <MDBox sx={{display: 'flex', flexDirection: 'column', justifyContent: 'space-between', width: '100%'}}>
              {
                  searchValue === "" && filteredSearchList.length >0&&
                  <MDBox>
                    <MDBox mb={2}>
                    <MDTypography variant="h6" fontWeight="medium">
                      {t("HelpCenter.Recent")}
                    </MDTypography>
                    </MDBox>

                    <Grid container spacing={1}>
                      {
                        filteredSearchList?.reverse().map((item, index) => {
                          return (
                              <Grid key={item.route} pb={0} item xs={12} md={12} mb={1} sx={{minWidth: 300,width: '100%'}}>
                                <NavLink
                                    to={`/app${item.route}`}
                                    onClick={() => {
                                      if (item.type === "tab")
                                      {
                                        localStorage.setItem(item.localStorageKey.key,item.localStorageKey.value)}                                      let currentSearchHistory = LocalStorage.getItem("searchHistory") ? JSON.parse(LocalStorage.getItem("searchHistory")) : []
                                      let newSearchHistory = currentSearchHistory.filter((e)=>e !== item.key)
                                      newSearchHistory.push(item.key);
                                      newSearchHistory = newSearchHistory.slice(-5);
                                      LocalStorage.setItem("searchHistory", JSON.stringify(newSearchHistory));
                                      handleCloseHelpCenter()
                                    }}
                                >
                                  <MDBox pl={1} sx={{display: "flex", justifyContent: "space-between",
                                    ":hover": {
                                      backgroundColor: darkMode ? "#3e3e3e" : "#f0f0f0", // 背景高亮色
                                      borderRadius: "8px", // 可选：增加圆角
                                      transition: "background-color 0.3s ease" // 平滑过渡效果
                                    } }}>
                                    <MDBox sx={{display: "flex",alignItems: "center"}}>
                                      <MDTypography  sx={{display: "flex",alignItems: "center"}}>
                                        <Icon fontSize="medium">history</Icon>
                                      </MDTypography>
                                      {/*<MDBox sx={{display: "flex",alignItems: "center"}}>*/}
                                      {/*  {item.icon}*/}
                                      {/*</MDBox>*/}
                                      <MDBox >
                                        <MDBox ml={2} sx={{display: "flex",flexDirection: "column",alignItems: "flex-start"}}>
                                          <MDTypography >
                                            { i18n.language === "zh" ? item.chineseName : item.name}
                                          </MDTypography>
                                          <MDTypography sx={{fontSize:"14px"}}>
                                            {item.parent? ( i18n.language === "zh" ? item.chineseNameParent : item.parent) :( i18n.language === "zh" ? "目录" : "Menu")}
                                          </MDTypography>
                                        </MDBox>
                                      </MDBox>
                                    </MDBox>
                                    <MDBox sx={{display:"flex",flexDirection: "row",alignItems: "center"}} mr={2}>
                                      <MDTypography>
                                        <Icon onClick={(e) => {
                                          e.preventDefault()
                                          e.stopPropagation()
                                          let currentSearchHistory = LocalStorage.getItem("searchHistory") ? JSON.parse(LocalStorage.getItem("searchHistory")) : []
                                          let newSearchHistory = currentSearchHistory.filter((e)=>e !== item.key)
                                          setSearchHistory(newSearchHistory); // 更新状态
                                          LocalStorage.setItem("searchHistory", JSON.stringify(newSearchHistory));
                                        }}>
                                          clear
                                        </Icon>
                                      </MDTypography>
                                    </MDBox>
                                  </MDBox>
                                </NavLink>
                              </Grid>
                          )
                        })
                      }
                    </Grid>
                  </MDBox>
              }
              {
                  searchValue !== "" && getSearchResult()?.length > 0
                  &&
                  <Grid container spacing={1}>
                    {
                      getSearchResult()?.map((item, index) => {
                        return (
                            <Grid pb={0} key={item.route}  item xs={12} md={12} mb={1} sx={{minWidth: 300,width: '100%'}}>
                              <NavLink to={`/app${item.route}`}
                                       onClick={()=>{
                                         if (item.type === "tab")
                                         {
                                           localStorage.setItem(item.localStorageKey.key,item.localStorageKey.value)}
                                         let currentSearchHistory = LocalStorage.getItem("searchHistory") ? JSON.parse(LocalStorage.getItem("searchHistory")) : []
                                         let newSearchHistory = currentSearchHistory.filter((e)=>e !== item.key)
                                         newSearchHistory.push(item.key);
                                         newSearchHistory = newSearchHistory.slice(-5);
                                         setSearchHistory(newSearchHistory);
                                         LocalStorage.setItem("searchHistory", JSON.stringify(newSearchHistory));
                                         handleCloseHelpCenter()
                                       }}
                              >
                                <MDBox pl={1} sx={{display: "flex" ,justifyContent: "space-between",
                                  width: '100%',
                                  ":hover": {
                                    backgroundColor: "#f0f0f0", // 背景高亮色
                                    borderRadius: "8px", // 可选：增加圆角
                                    transition: "background-color 0.3s ease" // 平滑过渡效果
                                  }

                                }}>
                                  <MDBox sx={{display: "flex",alignItems: "center",}}>
                                    <MDTypography sx={{display: "flex",alignItems: "center"}}>
                                      {item.icon}
                                    </MDTypography>
                                    <MDBox ml={2} sx={{display: "flex",flexDirection: "column",alignItems: "flex-start"}}>
                                      <MDTypography >
                                        { i18n.language === "zh" ? item.chineseName : item.name}
                                      </MDTypography>
                                      <MDTypography sx={{fontSize:"14px"}}>
                                        {item.parent? ( i18n.language === "zh" ? item.chineseNameParent : item.parent) :( i18n.language === "zh" ? "目录" : "Menu")}
                                      </MDTypography>
                                    </MDBox>
                                  </MDBox>
                                </MDBox>
                              </NavLink>
                            </Grid>
                        )
                      })
                    }
                  </Grid>
              }
              {
                  searchValue !== "" && (getSearchResult()?.length ===0)
                  &&
                  <Grid container spacing={2} mt={2}>
                    <Grid item xs={12} md={12} mb={2} sx={{minWidth: 300 }}>
                      <MDBox sx={{display: "flex" ,justifyContent: "center", }}>
                        <MDTypography>
                          <Icon fontSize="medium">search_off</Icon>
                          {/*<SearchOffIcon fontSize={'medium'} />*/}
                        </MDTypography>
                      </MDBox>
                      <MDBox sx={{display: "flex" ,justifyContent: "center", }}>
                        <MDTypography>
                          No results for "{searchValue}"
                        </MDTypography>
                      </MDBox>
                    </Grid>
                  </Grid>
              }
            </MDBox>
          </MDBox>
        </DialogContentText>
        <DialogActions>
          <MDTypography
              variant="body2"
              sx={{
                marginRight: 2,
                fontSize: '0.75rem',
                color: '#333', // 字体颜色更深，模拟按键上的文本
                // backgroundColor: '#f4f4f4', // 更接近键盘的浅灰背景
                padding: '2px 8px', // 稍微加宽
                borderRadius: '4px',
                fontWeight: 'bold',
                display: 'inline-block',
                boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)', // 添加阴影，增加立体感
                textAlign: 'center',
                whiteSpace: 'nowrap', // 防止文本换行
                letterSpacing: '0.5px', // 增加字母间距，增强键盘效果
              }}
          >
            Ctrl + K
          </MDTypography>
            {t("HelpCenter.to close")}
        </DialogActions>
      </DialogContent>
    </Dialog>
  }


  // Styles for the navbar icons
  const iconsStyle = ({ palette: { dark, white, text }, functions: { rgba } }) => ({
    color: () => {
      let colorValue = light || darkMode ? white.main : dark.main;

      if (transparentNavbar && !light) {
        colorValue = darkMode ? rgba(text.main, 0.6) : text.main;
      }
      return colorValue;
    },
  });

  const handleLanguageSelectChange = (event) => {
    dispatch(setLanguage(languageList.find((lang) => lang.value === event.target.value )?.lang));
    i18n.changeLanguage(languageList.find((lang) => lang.value === event.target.value )?.lang);
    setLanguageSelect(event.target.value);
  };
  const handleLanguageSelectClose = () => {
    setOpenLanguageSelect(false);
  };

  const handleLanguageSelectOpen = () => {
    setOpenLanguageSelect(true);
  };

  return (
    <AppBar
        id={'appBar'}
        position={absolute ? "absolute" : navbarType}
        color="inherit"
        sx={(theme) => navbar(theme, { transparentNavbar, absolute, light, darkMode })}
    >
      <Toolbar sx={(theme) => navbarContainer(theme)}>
        <MDBox color="inherit" mb={{ xs: 0, md: 0 }} sx={(theme) => navbarRow(theme, { isMini })}>
          <IconButton
              size="small"
              disableRipple
              color="inherit"
              sx={navbarMobileMenu}
              onClick={handleMiniSidenav}
          >
            <Icon sx={iconsStyle} fontSize="medium">
              {miniSidenav ? "menu" : "menu_open"}
            </Icon>
          </IconButton>
          <MDBox sx={{ display: "flex", alignItems: "center", minWidth: 0 }}>
            <IconButton
                size="small"
                disableRipple
                color="inherit"
                sx={{
                  display: { xs: "inline-flex", md: "none" },
                  p: 0,
                  mr: 0.25,
                  width: 22,
                  height: 22,
                  minWidth: 22,
                }}
                onClick={handleOpenHelpCenter}
            >
              <MDTypography
                  component="span"
                  variant="body2"
                  color={light ? "white" : "dark"}
                  opacity={light ? 0.8 : 0.5}
                  sx={{ lineHeight: 0 }}
              >
                <Icon>search</Icon>
              </MDTypography>
            </IconButton>
            <Breadcrumbs icon="home" title={route[route.length - 1]} route={route} light={light} />
          </MDBox>
        </MDBox>
        <ThemeProvider theme={muiTheme}>
          <Button size="small" variant="outlined"
                  sx={{
                    display: { xs: "none", md: "inline-flex" },
                    // marginRight: "20px",
                    borderWidth: '2px',
                    borderColor: colors.gradients[sidenavColor].main,   //'#7B809A', // 设置边框颜色为灰色
                    color: '#7B809A', // 设置文本颜色为灰色
                    borderRadius: '10px',
                    '&:hover': {
                      borderColor: colors.gradients[sidenavColor].state, //'darkgray',  // 悬停时边框颜色
                      backgroundColor: 'rgba(128, 128, 128, 0.1)', // 悬停时背景透明灰
                    },
                  }}
                  onClick={handleOpenHelpCenter}
                  startIcon={<SearchIcon />}>
            <MDBox sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <MDTypography
                  variant="body2"
                  sx={{
                    marginRight: 9,
                    '@media (max-width: 412px)': {
                      display: 'none',  // 在窄屏时隐藏
                    },
                  }}
              >
                  {t("HelpCenter.Search")}
              </MDTypography>
              <MDTypography
                  variant="body2"
                  sx={{
                    display: 'none', // 默认不显示
                    '@media (max-width: 412px)': {
                      display: 'inline', // 在窄屏时显示简短文本
                      fontSize: '0.75rem',
                    },
                  }}
              >
                Search...
              </MDTypography>
              {/*<MDTypography variant="body2" sx={{ marginRight: 9 }}>*/}
              {/*  Search Menus & Tabs...*/}
              {/*</MDTypography>*/}
              <MDTypography
                  variant="body2"
                  sx={{
                    fontSize: '0.75rem',
                    color: '#333', // 字体颜色更深，模拟按键上的文本
                    // backgroundColor: '#f4f4f4', // 更接近键盘的浅灰背景
                    padding: '2px 8px', // 稍微加宽
                    borderRadius: '4px',
                    fontWeight: 'bold',
                    display: 'inline-block',
                    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)', // 添加阴影，增加立体感
                    textAlign: 'center',
                    whiteSpace: 'nowrap', // 防止文本换行
                    letterSpacing: '0.5px', // 增加字母间距，增强键盘效果
                  }}
              >
                Ctrl + K
              </MDTypography>
            </MDBox>
          </Button>
        </ThemeProvider>
        {isMini ? null : (
          <MDBox sx={(theme) => navbarRow(theme, { isMini })}>
            {/*<MDBox pr={1}>*/}
            {/*  <MDInput label="Search here" />*/}
            {/*</MDBox>*/}
            <MDBox color={light ? "white" : "inherit"}>
              {process.env.REACT_APP_LANG_TRANSLATION === 'true' &&
              //     <IconButton
              //   size="small"
              //   disableRipple
              //   color="inherit"
              //   sx={navbarIconButton}
              //   onClick={handleToggleLanguage}
              // >
              //   <Icon sx={iconsStyle}>language</Icon>
              //   {/*{language!=='en'?<span><Typography  fontWeight={'medium'} variant={'caption'} color="secondary">中文</Typography> </span>*/}
              //   {/*    :<Typography  fontWeight={'medium'} variant={'caption'} color="secondary">EN</Typography>*/}
              //   {/*}*/}
              //   {language === 'en' && (
              //       <Typography fontWeight={'medium'} variant={'caption'} color="secondary">
              //         中文
              //       </Typography>
              //   )}
              //   {language === 'zh' && (
              //       <Typography fontWeight={'medium'} variant={'caption'} color="secondary">
              //         FR
              //       </Typography>
              //   )}
              //   {language === 'fr' && (
              //       <Typography fontWeight={'medium'} variant={'caption'} color="secondary">
              //         EN
              //       </Typography>
              //   )}
              // </IconButton>
                  <IconButton
                  size="small"
                  disableRipple
                  color="inherit"
                  sx={navbarIconButton}
                  >
                    <FormControl fullWidth>
                      <Select
                          sx={{
                            boxShadow: "none",
                            ".MuiOutlinedInput-notchedOutline": { border: 0 },
                            "&.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline":
                                {
                                  border: 0,
                                },
                            "&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                                {
                                  border: 0,
                                },
                          }}
                          open={openLanguageSelect}
                          value={languageSelect}
                          onChange={handleLanguageSelectChange}
                          onClose={handleLanguageSelectClose}
                          onOpen={handleLanguageSelectOpen}
                          renderValue={(value)=>{
                            return(
                                <MDButton sx={{padding:"4px"}} variant={'text'} color="info" startIcon={<LanguageIcon/>} onClick={handleLanguageSelectOpen}>
                                  {languageList.find(v=>v.value === value)?.label || ""}
                                </MDButton>
                            )
                          }}
                      >
                        <MenuItem value={1}>English</MenuItem>
                        <MenuItem value={2}>中文 (Chinese)</MenuItem>
                        <MenuItem value={3}>Français (Canada)</MenuItem>
                      </Select>
                    </FormControl>
                  </IconButton>
              }

              <IconButton sx={navbarIconButton}
                          aria-controls="notification-menu"
                          aria-haspopup="true"
                          variant="contained"
                          disableRipple
                          onClick={handleOpenAccount}
              >
                <Icon sx={iconsStyle}>account_circle</Icon>
                <MDTypography color={'text'} fontWeight={'medium'} variant={'caption'}>{LocalStorage.getItem('sub_username')}</MDTypography>
              </IconButton>

              <IconButton
                size="small"
                disableRipple
                color="inherit"
                sx={navbarIconButton}
                onClick={handleConfiguratorOpen}
              >
                <Icon sx={iconsStyle}>settings</Icon>
              </IconButton>
              {canListNotifications && (
                  <IconButton
                    size="small"
                    disableRipple
                    color="inherit"
                    sx={navbarIconButton}
                    aria-controls="notification-menu"
                    aria-haspopup="true"
                    variant="contained"
                    onClick={handleOpenMenu}
                  >
                    <Badge
                        variant="dot"
                        color="error"
                        invisible={!notificationBadgeCount}
                        sx={{
                          "& .MuiBadge-badge": {
                            minWidth: 8,
                            width: 8,
                            height: 8,
                            boxShadow: "0 0 0 2px #fff",
                          },
                        }}
                    >
                      <Icon sx={iconsStyle}>notifications</Icon>
                    </Badge>
                  </IconButton>
              )}
              {canListNotifications && renderMenu()}
              {renderAccount()}
              {/*{renderSupport()}*/}
              {renderHelpCenter()}
            </MDBox>
          </MDBox>
        )}
      </Toolbar>
    </AppBar>
  );
}

// Setting default values for the props of DashboardNavbar
DashboardNavbar.defaultProps = {
  absolute: false,
  light: false,
  isMini: false,
};

// Typechecking props for the DashboardNavbar
DashboardNavbar.propTypes = {
  absolute: PropTypes.bool,
  light: PropTypes.bool,
  isMini: PropTypes.bool,
};

export default DashboardNavbar;
